import { IEvent } from "@Interfaces";

export const getHidePaymentSummary = ({
    disablePayment,
    eventData = {} as IEvent.IEventData,
}: {
    disablePayment: boolean;
    eventData?: IEvent.IEventData;
}) => disablePayment || eventData.metadata?.hide_payment_summary;
